module.exports = __webpack_public_path__ + "static/img/eicad_item8.9d2b59b6.png";